import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoginEntityState } from './login-entity.state';
import { AuthState } from '../auth.state';

const selectAuthState = createFeatureSelector('auth');

export const selectLoginEntityState = createSelector(selectAuthState, (authState: AuthState) => authState.loginEntityState);

export const selectLoginEntity = createSelector(selectLoginEntityState, (state: LoginEntityState) => state.loginEntity);

export const selectLoginEntityLoading = createSelector(selectLoginEntityState, (state: LoginEntityState) => state.loginEntityLoading);
